"use client";

import { useEffect } from "react";
import Clarity from "@microsoft/clarity";

export default function ClarityAnalytics() {
  useEffect(() => {
    const projectId = "ybhqri23jv";

    if (!projectId) return;

    Clarity.init(projectId);
  }, []);

  return null;
}
